import mountDefaultValues from './mountDefaultValues'

export default {
  mountDefaultValues,
}
